/**
 * The club's own money formatting: "$76" / "$62.50" — whole dollars stay
 * whole, integer cents in.
 *
 * Deliberately NOT `formatPrice` from lib/format, which renders 0¢ as "Free"
 * because it was written for store prices. A share of nothing and a balance of
 * nothing both have to read as an honest "$0" on a page about money owed.
 */
export function formatCents(cents: number): string {
  const dollars = cents / 100
  return cents % 100 === 0 ? `$${dollars}` : `$${dollars.toFixed(2)}`
}
